module.exports = __webpack_public_path__ + "static/media/6-2.e067bc9a.mp3";